import {Component, computed, effect, input} from "@angular/core";
import {Translations} from "@translations";
import {FormControl, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatFormFieldModule, SubscriptSizing} from "@angular/material/form-field";
import {TranslateModule} from "@ngx-translate/core";
import {MatInputModule} from "@angular/material/input";
import {MatIcon} from "@angular/material/icon";
import {computedPrevious} from "ngxtension/computed-previous";

@Component({
	selector: "sim-duration-input",
	templateUrl: "./sim-duration-input.component.html",
	styleUrl: "./sim-duration-input.component.scss",
	imports: [TranslateModule, MatFormFieldModule, MatInputModule, MatIcon, ReactiveFormsModule],
})
export class SimDurationInputComponent {
	protected readonly T = Translations;

	public readonly formCtrl = input.required<FormControl<number>>();
	public readonly labelToken = input<string>();
	public readonly suffixFontIcon = input<string>();
	public readonly min = input<number | null>(null);
	public readonly max = input<number>(999);
	public readonly hintToken = input<string>();
	public readonly subscriptSizing = input<SubscriptSizing>("fixed");

	readonly #minValidator = computed(() => {
		const min = this.min();
		return min !== undefined && min !== null ? Validators.min(min) : Validators.nullValidator;
	});
	readonly #minValidatorPrev = computedPrevious(this.#minValidator);
	readonly #maxValidator = computed(() => Validators.max(this.max()));
	readonly #maxValidatorPrev = computedPrevious(this.#maxValidator);

	readonly #validatorEffect = effect(() => {
		const ctrl = this.formCtrl();
		const minValidatorPrev = this.#minValidatorPrev();
		const maxValidatorPrev = this.#maxValidatorPrev();
		const minValidator = this.#minValidator();
		const maxValidator = this.#maxValidator();

		if (ctrl.hasValidator(minValidatorPrev)) {
			ctrl.removeValidators(minValidatorPrev);
		}

		if (ctrl.hasValidator(maxValidatorPrev)) {
			ctrl.removeValidators(maxValidatorPrev);
		}

		if (!ctrl.hasValidator(minValidator)) {
			ctrl.addValidators(minValidator);
		}

		if (!ctrl.hasValidator(maxValidator)) {
			ctrl.addValidators(maxValidator);
		}
	});
}
